// 1. Import the functions
const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export const Header = {
	state: {
		searchOpen: false,
		sticky: false,
		menuMobileOpen: false,
		subMenuDesktopOpen: false,
		device: null
	},

	constructor() {
		// console.log('F // gestion du header');
		this.header = document.querySelector('.header');
		this.notHeader = document.querySelector(':not(.header)');
	},

	init() {
		if (document.querySelector('.header')) {
			this.constructor();
			this.checkDevice.init();

			// fonctions du header
			// comportement sticky
			this.Sticky.init();

			// recherche
			this.Search.init();

			// sous menu
			this.Menu.init()
		
			//
		}
	},

	Sticky: {
		init() {
			// changement de l'état au scroll
			let headerHeight = Header.header.clientHeight;

			window.addEventListener('scroll', () => {
				if (Header.state.device.desktop) {
					

					if (window.scrollY >= headerHeight || window.pageYOffset >= headerHeight) {
						this.add(headerHeight);
					} else {
						this.remove();
					}
				}
			});
		},
		add(headerHeight) {
			Header.header.classList.add('sticky');
			Header.state.sticky = true;
			document.querySelector('#page').style.marginTop = headerHeight + 'px';
		},
		remove() {
			Header.header.classList.remove('sticky');
			Header.state.sticky = false;
			document.querySelector('#page').style.marginTop = null;
			
		}
	},

	Search: {
		searchBtn: document.querySelector('.header .header__search'),
		formSearch: document.querySelector('.header .header__formSearch'),

		init() {
			this.searchBtn.onclick = () => {
				console.log("clic")
				if(	Header.state.searchOpen){
					this.close()
				}else{
					Header.Menu.closeSubMenu();
					this.open();
				}
			};

			document.onclick = (e) => {
				if (!e.target.closest('.header') && Header.state.searchOpen) {
					this.close();
				}
			};
		
			
		},

		open() {
			Header.state.searchOpen = true;
			this.formSearch.classList.add('show');
			this.formSearch.querySelector('input').focus();

		},

		close() {
			this.formSearch.classList.remove('show');
			Header.state.searchOpen = false;
		}
	},

	Menu: {
		nav: document.querySelector('.header .header__nav'),
		menu: document.querySelector('.header .menu'),
		menuItemAll: '.header .menu > .menu-item',
		menuItem: '.header .menu > .menu-item',
		subMenu: document.querySelector('.header .sub-menu') ,
		subMenuItem: document.querySelectorAll('.header .menu .sub-menu li a'),
		subMenuDesktop: document.querySelector('.header__subMenu__wrapper'),
		subMenuWrapper: document.querySelector('.header__subMenu'),
		toggle: document.querySelector('.header #btn-menu'),

		init(){

			// desktop
			document.addEventListener( 'mouseover', (e) => { this.displaySubMenu(e) }, false );
		

			// mobile
			this.createAccordeon();
			this.toggle.onclick = () => {this.toggleMenu()};

			// ouverture sous menu
			this.menu.addEventListener('click', (e)=>{
				if(e.target.closest('.btn-arrow')){
					e.target.parentNode.querySelector('.sub-menu').classList.toggle("open");
					e.target.classList.toggle('open');
					e.target.parentNode.classList.toggle('open');
				}
			})
		
		},
		
		// -------------------
		// MENU DESKTOP
		// -------------------
		
		displaySubMenu(e){
			if(Header.state.device.desktop){
				// console.log("F // displaySubMenu");

					if (e.target.closest('.header__top') || e.target.closest('.sub-menu')) {
						if (e.target.closest(this.menuItem)) {
							this.openSubMenu(e)
						}
					} else {
						this.closeSubMenu()
					}
				}
		},

		openSubMenu(e){
			this.subMenuWrapper.classList.add('show');
			Header.state.subMenuDesktopOpen = true;

			if (e.target.parentNode.querySelector('.sub-menu')) {
				this.subMenuWrapper.innerHTML = e.target.parentNode.querySelector(
					'.sub-menu'
				).outerHTML;
			} else {
				this.subMenuWrapper.innerHTML = '';
			}
		}, 
		closeSubMenu(){

			if (Header.state.subMenuDesktopOpen) {
				this.subMenuWrapper.classList.remove('show');
				Header.state.subMenuDesktopOpen = false;
			}
		},

		// -------------------
		// MENU MOBILE
		// -------------------

		toggleMenu() {
			// console.log('F // gestion menu toggle');
			if(!Header.state.menuMobileOpen){
				this.openMenuMobile();
			}else{
				this.closeMenuMobile();
			}
		},

		createAccordeon(){
			const buttonMarkup = '<div class="btn-arrow"></div>';
			document.querySelectorAll(this.menuItemAll).forEach( items => {
				if (items.querySelector('.sub-menu')) {
					items.querySelector('a').insertAdjacentHTML('afterend', buttonMarkup);
				};
			});
		},

		openMenuMobile(){
			this.nav.classList.add("show");
			this.toggle.classList.add('open');
			Header.Search.searchBtn.style.display = "none";

			// Hauteur
			let size = window.innerHeight - document.querySelector('.header__wrapper__top').clientHeight;
			this.nav.style.height = size + "px";
			document.documentElement.style.overflow="hidden"
			disableBodyScroll(this.nav);

			// update State
			Header.state.menuMobileOpen = true;
			
		}, 

		closeMenuMobile(){
			document.documentElement.style.overflow="initial"
			this.nav.classList.remove("show");
			this.toggle.classList.remove('open');
			Header.Search.searchBtn.style.display = null;
			this.nav.style.height = null;

			enableBodyScroll(this.nav);
			// update State
			Header.state.menuMobileOpen = false;

		},

		// SOUS MENU
		toggleAccordeon(){
			
			if(document.querySelector('.sub-menu .btn-arrow')){
				document.querySelector('.btn-arrow')
			}
		}

	},

	checkDevice: {
		init() {
			let mql = window.matchMedia('(max-width:1024px)');
			this.screenTest(mql);
			mql.addListener(this.screenTest);
		},

		screenTest(e) {
			if (e.matches) {
				// mobile
				Header.state.device = { mobile: true, desktop: false };
				document.querySelector('#page')				

				// console.log(Header.state.device);
			} else {
				// desktop
				Header.state.device = { mobile: false, desktop: true };
				Header.Menu.closeMenuMobile()

				// console.log(Header.state.device);
			}
		}
	}
};
